import type { PsHttpSSE } from '@/services/sse-ps-http/sse-ps-http';
import { StreamStatus } from '@/services/sse-ps-http/enums';

export const GetSpecificationClaimFeaturesApi = Symbol.for('GetSpecificationClaimFeaturesApi');

export interface ApiGetSpecificationClaimFeaturesRequest {
    task_id: string;
}

export type ApiGetSpecificationClaimFeaturesResponse = {
    content: {
        feature_tree: Array<{
            /** 权利要求编号 */
            num: string;

            /** 权利要求内容 */
            simple_claim: string;

            /** 特征列表 */
            claim_features?: {
                /** 特征内容, 特征短语 */
                feature: string;
                /** 特征词列表 */
                concepts?: string[];
            }[];

            /** 从权才有这个值，代表其附属于哪个主权 */
            parent?: string;
        }>
    }
    status: StreamStatus;
}

export interface GetSpecificationClaimFeaturesApi {
    getSpecificationClaimFeatures(data: ApiGetSpecificationClaimFeaturesRequest): PsHttpSSE<ApiGetSpecificationClaimFeaturesResponse>;
}
